import React from 'react'
import FacetsContainer from 'redux/containers/components/search/FacetsContainer'

const SearchFacets = (props) => (
  <div className='bg-ghost-grey'>
    <FacetsContainer {...props} />
  </div>
)

export default SearchFacets
